import { createRequest } from "src/base/http/axios";
import { METHOD } from "src/config";

interface IRead {
  page?: number;
  limit?: number;
}

interface IGet {
  id: number;
}

const API = {
  read: (payload = {}) => {
    return createRequest({
      method: METHOD.GET,
      endpoint: "/carts",
      payload,
      crossDomain: true,
      headers: {
        "X-Request-With-Khanhnc": "enable_session",
      },
    });
  },
  store: (payload = {}) => {
    let method = METHOD.POST;
    if (payload.hasOwnProperty("id")) {
      method = METHOD.PUT;
    }

    return createRequest({
      method,
      endpoint: "/carts",
      payload,
      crossDomain: true,
      headers: {
        "X-Request-With-Khanhnc": "enable_session",
      },
    });
  },
};

export default API;
